import { useEffect } from 'react';

const API_KEY = 'AIzaSyBpAjNh5e67TFz5XRlpu05hepRe_JC4GMY';

const GoogleMapsLoader = ({ onLoad, onError }) => {
  useEffect(() => {
    // Kiểm tra nếu API đã được tải
    if (window.google && window.google.maps) {
      if (onLoad) onLoad();
      return;
    }

    // Phương pháp tải được khuyến nghị bởi Google
    // https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
    
    // Tạo function xử lý khi API đã tải xong
    const handleApiLoaded = () => {
      if (onLoad) onLoad();
    };

    // Tạo function xử lý lỗi
    const handleApiError = () => {
      console.error('Không thể tải Google Maps API');
      if (onError) onError(new Error('Không thể tải Google Maps API'));
    };

    // Tạo script element đúng cách với async
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places,geometry,visualization&callback=initMap&loading=async&v=weekly`;
    script.async = true;
    script.defer = true;
    script.onerror = handleApiError;
    
    // Định nghĩa hàm callback toàn cục
    window.initMap = handleApiLoaded;
    
    // Thêm script vào document
    document.head.appendChild(script);

    // Dọn dẹp khi component unmount
    return () => {
      // Xóa callback global
      window.initMap = undefined;
      
      // Xóa script nếu vẫn đang tải
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [onLoad, onError]);

  return null; // Component này không render gì cả
};

export default GoogleMapsLoader; 